import React from 'react';
import { AuditTab } from 'areas/shared/components';

class AuditInfoTab extends React.Component {

    render() {
        let entityId = this.props.selectedId && this.props.selectedId.includes('@')
            ? this.props.selectedId.substr(0, this.props.selectedId.indexOf('@'))
            : this.props.selectedId;

        let opts = {
            entityType: "DD214",
            tabKey: this.props.tabKey,
            active: this.props.active,
            helpKey: this.props.helpKey,
            selectedId: entityId,
            title: this.props.title
        };

        return (
            <React.Fragment>
                <AuditTab {...opts} />
            </React.Fragment>
        );
    }
}

export default AuditInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/dd214Setup/auditInfo/AuditInfoTab.js